import { MutationFunction, MutationKey, UseMutationResult } from '@tanstack/react-query';
import { RequestError } from '@utils/request/request.type';

import { GenericMutationOptions, useGenericMutation } from './use-generic-mutation';

export interface UseEventMutationOptions<TData, TError, TVariables, TContext>
  extends GenericMutationOptions<TData, TError, TVariables, TContext> {
  eventId?: string;
}

export const useEventMutation = <TData = unknown, TError = RequestError, TVariables = void, TContext = unknown>(
  key: MutationKey,
  fn: MutationFunction<TData, TVariables>,
  options?: UseEventMutationOptions<TData, TError, TVariables, TContext>,
  hideError?: boolean
): UseMutationResult<TData, TError, TVariables, TContext> => {
  const { eventId, ...restOptions } = options ?? {};

  return useGenericMutation<TData, TError, TVariables, TContext>(
    key,
    fn,
    {
      ...restOptions,
      meta: {
        ...restOptions.meta,
        eventId,
      },
    },
    hideError
  );
};
